<template>
    <div class="song-release-progress">已发布{{ usageCount }}首（限制提交{{ trackLimitCount }}首） </div>
</template>
<script>
export default {
    data() {
        return {
            usageCount: 0,
            trackLimitCount: 0
        };
    },
    created() {
        this.fetch();
    },
    methods: {
        async fetch() {
            const response = await this.$request.get('/msg/sys_msg/sys_track_limit');
            const { state, msg, result } = response.data;
            if (!state) throw new Error(msg || '获取歌曲发布数量失败');
            this.usageCount = result.usageCount;
            this.trackLimitCount = result.trackLimitCount;
        }
    }
};
</script>
<style lang="scss" scoped>
.song-release-progress {
    position: relative;
    height: 25px;
    background: #E1F1F0;
    font-size: 14px;
    color: #65B8B3;
    text-align: left;
    line-height: 25px;
    padding: 0 20px;
    display: inline-block;
    border-radius: 4px;

    &::before {
        content: "";
        position: absolute;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 8px 6px 8px 0;
        border-color: transparent #E1F1F0 transparent transparent;
        left: -6px;
        top: 5px;
    }
}
</style>
